import React from 'react';
import FriendsManager from './FriendsManager';
import PageHero from './PageHero';
import PageHelp from './PageHelp';

export default function Friends() {
  return (
    <div className="friends-page">
      <PageHero
        eyebrow="Friends + team"
        title="Friends / Team"
      />
      <div className="page-toolbar">
        <PageHelp
          title="How to use Friends / Team"
          description="Keep private sharing and team collaboration organized in one workspace."
          tips={[
            'Add friends to unlock private sharing without public links.',
            'Use the Team tab to manage roles and access for collaborators.',
            'Remove or archive connections anytime.'
          ]}
          subject="Photo Harbor Help - Friends & Team"
        />
      </div>

      <div className="friends-container page-surface">
        <FriendsManager />
      </div>
    </div>
  );
}
